const schema = () => ({
  type: "object",
  required: [],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
    },
    amount: {
      type: "string",
      title: "قیمت",
    },
    lab_quantity: {
      type: "string",
      title: "تعداد لابراتوار",
    },
    unit_quantity: {
      type: "string",
      title: "تعداد کلینیک",
    },
    doctor_quantity: {
      type: "string",
      title: "تعداد پزشک",
    },
    validity_months: {
      type: "string",
      title: "اعتبار",
      oneOf: [
        { const: "1", title: "یک ماه" },
        { const: "3", title: "سه ماه" },
        { const: "6", title: "شش ماه" },
        { const: "12", title: "یک سال" },
      ],
    },
    related_to: {
      type: "string",
      title: "نوع",
      oneOf: [
        { const: "unit", title: "کلینیک" },
        { const: "labratoar", title: "لابراتوار" },
      ],
    },
    details: {
      type: "string",
      title: "توضیحات",
    },
  },
});

export default schema;
